import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { RestService } from '../../../../shared/services/rest.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { UserRepository } from '../../../user/states/user.repository';
import { AnimalMedicalConditionModel, AnimalMedicalConditionCreatePayload, AnimalMedicalConditionUpdatePayload } from '../../models/medical/animal-medical-condition.model';
import { AnimalMedicalCrudRepository } from './animal-medical-crud.repository';

@Injectable({ providedIn: 'root' })
export class AnimalMedicalConditionRepository extends AnimalMedicalCrudRepository<AnimalMedicalConditionModel, AnimalMedicalConditionCreatePayload, AnimalMedicalConditionUpdatePayload> {
  protected readonly path = '/animal_medical_conditions';
  protected readonly toastKey = 'condition';

  constructor(
    restService: RestService,
    toast: ToastService,
    translateService: TranslocoService,
    userRepository: UserRepository
  ) {
    super(restService, toast, translateService, userRepository);
  }
}
